import {POCar} from '@obj-models/POCar';
import {PORequest} from '@obj-models/PORequest';

export class POActiveCars {
  static type = 'ActiveCars';

  car: POCar | number = null;
  request: PORequest | number = null;
}
